export default {
	name: 'shellypirnb',
	friendly_name: 'PIR NB',
	family: 'sensor',
	isPM: false,
	is_nb: true,
	availableViews: ['basic'],
	modes: ['sensor'],
	settings: [{ title: 'not_ready' }],
};
